import {useEffect, useRef, useState} from 'react'
import {equals} from 'ramda'

function useRenderPersistedArray<T = any>(array: T[]): T[] {
  const [aryVal, setAryVal] = useState(array)
  const aryRef = useRef(array)
  useEffect(() => {
    if (!equals(array, aryRef.current)) {
      aryRef.current = array
      setAryVal(array)
    }
  }, [array])

  return aryVal
}

export default useRenderPersistedArray
